export const declarationsDe = {
  title: 'Deklarationen und Allergene',
  subtitle:
    'Mehrsprachige, versionierte Vorschläge aus freigegebenen Rezepturen mit kontrollierter Rechtsprüfung.',
  help: 'Hilfe zu Deklarationen, Katalogbegriffen und Freigaben öffnen',
  empty: 'Keine Deklarationsversion entspricht den gewählten Filtern.',
  pagination: 'Seite {{page}} von {{pages}} · {{total}} Versionen',
  actions: {
    catalog: 'Fachkatalog',
    generate: 'Vorschlag erzeugen',
    newTerm: 'Katalogeintrag',
    submit: 'Zur Prüfung',
    review: 'Prüfung abschließen',
    approve: 'Freigeben',
    publish: 'Veröffentlichen',
    archive: 'Archivieren',
    copy: 'Neue Version',
    override: 'Begründet übersteuern',
    confirm: 'Bestätigen',
    history: 'Versionen',
  },
  filters: {
    search: 'Nummer, Produkt, Markt oder Begriff suchen',
    allStatuses: 'Alle Status',
    allTypes: 'Alle Typen',
  },
  statuses: {
    DRAFT: 'Entwurf',
    VALIDATION_ERROR: 'Validierungsfehler',
    IN_REVIEW: 'In Prüfung',
    APPROVED: 'Freigegeben',
    PUBLISHED: 'Veröffentlicht',
    SUPERSEDED: 'Ersetzt',
    ARCHIVED: 'Archiviert',
  },
  catalogStatuses: {
    DRAFT: 'Entwurf',
    IN_REVIEW: 'In Prüfung',
    APPROVED: 'Freigegeben',
    SUPERSEDED: 'Ersetzt',
    ARCHIVED: 'Archiviert',
  },
  allergenStatuses: {
    CONTAINS: 'Enthalten',
    MAY_CONTAIN: 'Kann enthalten',
    DOES_NOT_CONTAIN: 'Nicht enthalten',
    UNKNOWN: 'Unbekannt',
  },
  issueSeverity: { ERROR: 'Fehler', WARNING: 'Warnung' },
  types: {
    INGREDIENT: 'Zutat',
    ALLERGEN: 'Allergen',
    ADDITIVE: 'Zusatzstoff',
    FUNCTION_CLASS: 'Funktionsklasse',
    ORIGIN_STATEMENT: 'Herkunftsangabe',
    COLLECTIVE_DESIGNATION: 'Sammelbezeichnung',
    WARNING: 'Warnhinweis',
    CLAIM: 'Claim',
    PRODUCT_DESIGNATION: 'Verkehrs-/Produktbezeichnung',
    QUID_RULE: 'QUID-Regel',
  },
  columns: {
    number: 'Nummer',
    product: 'Produkt',
    market: 'Markt',
    version: 'Version',
    status: 'Status',
    issues: 'Fehler / Warnungen',
    updated: 'Geändert',
    key: 'Schlüssel',
    type: 'Typ',
    name: 'Bezeichnung',
    validity: 'Gültigkeit',
    path: 'Quelle / Pfad',
    weight: 'Relevantes Gewicht',
    percentage: 'Anteil',
    flags: 'Kennzeichen',
    field: 'Feld',
    recipe: 'Rezeptur',
  },
  fields: {
    key: 'Stabiler Schlüssel',
    type: 'Fachtyp',
    code: 'Code / E-Nummer',
    metadata: 'Konfigurierbare Metadaten (JSON)',
    validFrom: 'Gültig ab',
    validTo: 'Gültig bis',
    changeReason: 'Änderungsgrund',
    name: 'Bezeichnung',
    synonyms: 'Synonyme, komma-getrennt',
    description: 'Beschreibung',
    reason: 'Prüf- oder Entscheidungsvermerk',
    recipe: 'Freigegebene Rezepturversion',
    number: 'Deklarationsnummer (optional)',
    market: 'Markt-/Regelwerk-Schlüssel',
    ingredients: 'Zutatenverzeichnis',
    allergens: 'Allergenhinweis',
    additives: 'Zusatzstoffe',
    warnings: 'Warnhinweise und Herkunft',
    productDesignation: 'Verkehrs-/Produktbezeichnung',
    ingredientText: 'Zutatenverzeichnis',
    allergenText: 'Allergenhinweis',
    additiveText: 'Zusatzstofftext',
    warningText: 'Warnhinweise und Herkunft',
    overrideReason: 'Begründung der manuellen Abweichung',
    warningAcknowledgement: 'Begründete Bestätigung aller verbleibenden Warnungen',
  },
  catalog: {
    title: 'Konfigurierbarer Deklarationskatalog',
    subtitle:
      'Versionierte Zutaten, Allergene, Zusatzstoffe, Funktionsklassen, Regeln und sprachabhängige Begriffe.',
    empty: 'Keine Katalogversion gefunden.',
    createTitle: 'Katalogeintrag anlegen',
    editTitle: 'Katalogversion v{{version}} bearbeiten',
    editorHelp:
      'Zahlen in Metadaten werden als Dezimalzeichenfolgen gespeichert. Vor der Prüfung müssen alle unterstützten Sprachen vollständig sein.',
    historyTitle: 'Versionshistorie: {{key}}',
    historyDescription:
      'Freigegebene Begriffe bleiben unveränderlich; Änderungen entstehen als neue Version.',
  },
  generate: {
    title: 'Deklarationsvorschlag erzeugen',
    description:
      'Die Engine löst die freigegebene BOM, Unterrezepturen und zusammengesetzte Zutaten reproduzierbar auf.',
    legalWarning:
      'Dies ist keine automatische rechtliche Freigabe. Das Ergebnis benötigt eine unabhängige fachliche Prüfung und eine ausdrückliche Veröffentlichung.',
  },
  detail: {
    subtitle: 'Version {{version}} · Markt {{market}} · Quelle {{recipe}} v{{recipeVersion}}',
  },
  legal: {
    title: 'Fachliche und rechtliche Prüfung erforderlich',
    description:
      'Der berechnete Vorschlag, QUID-Kennzeichen, Claims, Warnungen und Übersetzungen müssen vor rechtsverbindlicher Nutzung von qualifizierten Personen geprüft werden.',
  },
  summary: {
    status: 'Workflowstatus',
    ingredients: 'Zutatenpositionen',
    allergens: 'Allergenbefunde',
    errors: 'Validierungsfehler',
    warnings: 'Warnungen',
  },
  tabs: {
    preview: 'Sprachvorschau',
    comparison: 'Sprachvergleich',
    sources: 'Quellen und Snapshot',
    validation: 'Validierung',
    history: 'Versionshistorie',
  },
  sections: {
    ingredients: 'Gewichtssortierte Zutaten',
    allergens: 'Abgeleitete Allergene',
    additives: 'Zusatzstoffe und Funktionsklassen',
    sourceSnapshot: 'Unveränderlicher Herkunftsnachweis',
    validation: 'Validierungs- und Datenqualitätsprüfung',
    history: 'Deklarationsrevisionen',
  },
  preview: {
    ingredientText: 'Effektive, freizugebende Fassung dieser Sprache.',
    sorting:
      'Reihenfolge und Prozentwerte wurden dezimalgenau aus dem Deklarationsgewicht berechnet.',
    unknownWarning: '„Unbekannt“ wird niemals als „nicht enthalten“ gewertet.',
  },
  comparison: {
    title: 'Alle unterstützten Sprachen im Vergleich',
    description: 'Gelb markierte Werte weichen begründet vom automatisch berechneten Text ab.',
    automatic: 'Automatisch berechnete Fassung anzeigen',
  },
  sources: {
    description:
      'Konkrete freigegebene Versionen und Hash machen die Berechnung später reproduzierbar.',
    approvedAt: 'Rezeptur freigegeben am',
    profiles: 'Rohstoffprofil-Versionen',
    catalogVersions: 'Katalogversionen',
    materialSources: 'Rohstoffquellen',
  },
  validation: {
    description:
      'Fehler sperren die Prüfung. Warnungen müssen vor der Freigabe ausdrücklich bewertet und bestätigt werden.',
  },
  history: {
    description: 'Veröffentlichte Versionen bleiben als vollständige Snapshots unverändert.',
  },
  states: {
    noAllergens: 'Keine Allergenbefunde aus den freigegebenen Quelldaten.',
    noAdditives: 'Keine Zusatzstoffe aus den freigegebenen Quelldaten.',
    noIssues: 'Keine Validierungsfehler oder Datenqualitätswarnungen.',
    notFound: 'Die Deklarationsversion wurde nicht gefunden.',
  },
  override: {
    title: 'Manuelle Abweichungen dokumentieren',
    description:
      'Automatische Texte bleiben im Snapshot erhalten. Jede Änderung wird als Abweichung mit gemeinsamer fachlicher Begründung protokolliert.',
  },
  publish: {
    confirmation:
      'Mit der Bestätigung wird exakt dieser freigegebene Snapshot veröffentlicht und unveränderlich. Die Veröffentlichung ersetzt keine externe Rechtsberatung.',
  },
  actionDialog: {
    APPROVE: {
      title: 'Deklaration freigeben',
      description:
        'Die unabhängige Freigabe friert diese Version ein. Verbleibende Warnungen benötigen eine nachvollziehbare Bestätigung.',
    },
    COPY: {
      title: 'Neue Katalogversion erzeugen',
      description: 'Der Inhalt wird als neuer bearbeitbarer Entwurf kopiert.',
    },
    ARCHIVE: {
      title: 'Version archivieren',
      description:
        'Die Version bleibt revisionssicher erhalten, ist aber nicht mehr für neue Verwendungen aktiv.',
    },
    REVIEW: {
      title: 'Fachprüfung abschließen',
      description:
        'Dokumentiere die unabhängige Prüfung der Quellen, Berechnung, Sprache und Warnungen.',
    },
    PUBLISH: {
      title: 'Deklaration ausdrücklich veröffentlichen',
      description:
        'Die Veröffentlichung ist ein eigener, rechtlich relevanter Schritt nach der Freigabe.',
    },
  },
  messages: {
    generated: 'Deklarationsvorschlag wurde reproduzierbar erzeugt.',
    saved: 'Katalogversion gespeichert.',
    overrideSaved: 'Manuelle Abweichungen wurden protokolliert.',
    submitted: 'Deklaration wurde zur unabhängigen Prüfung eingereicht.',
    workflow: 'Workflow wurde revisionssicher aktualisiert.',
  },
} as const;
